/* ============================================================
   Refy-inspired Beauty Theme - JavaScript
   ============================================================ */
(function () {
  'use strict';

  var routes = window.routes || {};
  var strings = window.cartStrings || {};

  /* ---------- Helpers ---------- */
  function formatMoney(cents) {
    return '\u20AC' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function showToast(message) {
    var toast = document.querySelector('.cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cart-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2800);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (b) {
      b.textContent = count;
      if (b.classList.contains('cart-count-bubble')) {
        b.style.display = count > 0 ? 'flex' : 'none';
      }
    });
  }

  /* ---------- Sticky / transparent header ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var isTransparent = header.getAttribute('data-transparent') === 'true'
      && document.body.classList.contains('template-index');

    function onScroll() {
      if (isTransparent) {
        if (window.scrollY > 40) {
          header.classList.remove('is-top');
        } else {
          header.classList.add('is-top');
        }
      }
    }
    if (isTransparent) {
      document.body.classList.add('has-transparent-header');
      header.classList.add('is-top');
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var toggles = document.querySelectorAll('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    var overlay = document.querySelector('[data-drawer-overlay]');
    if (!nav) return;

    function open() {
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-visible');
      document.body.classList.add('drawer-open');
    }
    function close() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-visible');
      document.body.classList.remove('drawer-open');
    }
    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        nav.classList.contains('is-open') ? close() : open();
      });
    });
    if (overlay) overlay.addEventListener('click', close);
    nav._close = close;
  }

  /* ---------- Search panel ---------- */
  function initSearch() {
    var toggle = document.querySelector('[data-search-toggle]');
    var panel = document.querySelector('[data-search-panel]');
    var close = document.querySelector('[data-search-close]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) { var input = panel.querySelector('input'); if (input) input.focus(); }
    });
    if (close) close.addEventListener('click', function () {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
    });
  }

  /* ---------- Cart drawer ---------- */
  function openCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-drawer-overlay]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-visible');
    document.body.classList.add('drawer-open');
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-drawer-overlay]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.classList.remove('drawer-open');
  }

  function fetchCartJson() {
    return fetch((routes.cart_url || '/cart') + '.js')
      .then(function (r) { return r.json(); });
  }

  function rebuildDrawer(cart) {
    var body = document.querySelector('[data-cart-drawer-body]');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cart-drawer__empty">' +
        '<p>' + (strings.emptyText || 'Your cart is currently empty.') + '</p>' +
        '<a href="' + (routes.all_products_url || '/collections/all') + '" class="btn btn--primary">Continue Shopping</a>' +
        '</div>';
      return;
    }

    /* -- Shipping bar (gratis verzending bij 2+ producten) -- */
    var minItems = 2;
    var count = cart.item_count;
    var pct = Math.min(Math.round((Math.min(count, minItems) / minItems) * 100), 100);
    var shippingLabel;
    if (count >= minItems) {
      shippingLabel = '<p class="cart-drawer__shipping-label cart-drawer__shipping-label--success">\uD83C\uDF89 You qualify for free shipping!</p>';
    } else {
      var needed = minItems - count;
      shippingLabel = '<p class="cart-drawer__shipping-label">Add <strong>' + needed +
        ' more product' + (needed > 1 ? 's' : '') + '</strong> for free shipping!</p>';
    }
    var shippingBar =
      '<div class="cart-drawer__shipping-bar">' +
      shippingLabel +
      '<div class="cart-drawer__progress-track"><div class="cart-drawer__progress-fill" style="width:' + pct + '%;"></div></div>' +
      '</div>';

    /* -- Cart items -- */
    var closeSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="14" height="14">' +
      '<path d="M18.75 5.13496L5.25 18.8544" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '<path d="M18.75 18.8544L5.25 5.13496" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '</svg>';

    var itemsHtml = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image + '&width=160" alt="" width="80" loading="lazy">'
        : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-drawer-item__variant">' + item.variant_title + '</p>'
        : '';
      return (
        '<li class="cart-drawer-item" data-cart-item data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="cart-drawer-item__media">' + img + '</a>' +
        '<div class="cart-drawer-item__details">' +
        '<div class="cart-drawer-item__top">' +
        '<a href="' + item.url + '" class="cart-drawer-item__title">' + item.product_title + '</a>' +
        '<button type="button" class="cart-drawer-item__remove-icon" data-cart-remove data-key="' + item.key + '" aria-label="Remove">' + closeSvg + '</button>' +
        '</div>' +
        variant +
        '<p class="cart-drawer-item__price">' + formatMoney(item.final_price) + '</p>' +
        '<div class="cart-drawer-item__actions">' +
        '<div class="quantity-selector quantity-selector--sm quantity-selector--pill">' +
        '<button type="button" class="quantity-selector__btn" data-cart-minus data-key="' + item.key + '">&minus;</button>' +
        '<input type="number" class="quantity-selector__input" value="' + item.quantity + '" min="0" data-cart-quantity data-key="' + item.key + '">' +
        '<button type="button" class="quantity-selector__btn" data-cart-plus data-key="' + item.key + '">&plus;</button>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</li>'
      );
    }).join('');

    /* -- Discount toggle -- */
    var tagSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 14 15" fill="none">' +
      '<path d="M2.31547 8.06547C2.23358 7.98349 2.18755 7.87236 2.1875 7.75648V2.6875H7.25648C7.37236 2.68755 7.48349 2.73358 7.56547 2.81547L12.997 8.24703C13.079 8.32907 13.1251 8.44031 13.1251 8.55629C13.1251 8.67227 13.079 8.78351 12.997 8.86555L8.36719 13.497C8.28515 13.579 8.17391 13.6251 8.05793 13.6251C7.94195 13.6251 7.83071 13.579 7.74867 13.497L2.31547 8.06547Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '<path d="M4.59375 5.75C4.95619 5.75 5.25 5.45619 5.25 5.09375C5.25 4.73131 4.95619 4.4375 4.59375 4.4375C4.23131 4.4375 3.9375 4.73131 3.9375 5.09375C3.9375 5.45619 4.23131 5.75 4.59375 5.75Z" fill="currentColor"></path>' +
      '</svg>';

    var discountSection =
      '<div class="cart-drawer__discount-section">' +
      '<button type="button" class="cart-drawer__discount-toggle" aria-expanded="false" aria-controls="CartDiscountForm">' +
      tagSvg + ' Add discount code' +
      '</button>' +
      '<div id="CartDiscountForm" hidden>' +
      '<form action="/cart" method="POST" style="display:flex;gap:8px;margin-top:10px;">' +
      '<input type="text" name="discount" placeholder="Enter discount code" style="flex:1;padding:10px 12px;border:1px solid #e8e0d8;font-size:13px;">' +
      '<button type="submit" class="btn btn--primary" style="padding:10px 16px;font-size:12px;">Apply</button>' +
      '</form>' +
      '</div>' +
      '</div>';

    var cartUrl = routes.cart_url || '/cart';

    body.innerHTML =
      shippingBar +
      '<ul class="cart-drawer__items" data-cart-items>' + itemsHtml + '</ul>' +
      '<div class="cart-drawer__footer">' +
      discountSection +
      '<div class="cart-drawer__subtotal">' +
      '<span class="cart-drawer__total-label">Total</span>' +
      '<span class="cart-drawer__total-value" data-cart-subtotal>' + formatMoney(cart.total_price) + '</span>' +
      '</div>' +
      '<p class="cart-drawer__shipping-note">Free shipping on orders of 2 or more products</p>' +
      '<div class="cart-drawer__buttons">' +
      '<a href="' + cartUrl + '" class="btn btn--outline">View Cart</a>' +
      '<form action="' + cartUrl + '" method="post" style="flex:2;">' +
      '<button type="submit" name="checkout" class="btn btn--primary btn--full">Checkout</button>' +
      '</form>' +
      '</div>' +
      '</div>';

    /* -- Discount toggle event opnieuw koppelen -- */
    var toggle = body.querySelector('.cart-drawer__discount-toggle');
    var form = body.querySelector('#CartDiscountForm');
    if (toggle && form) {
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        expanded ? form.setAttribute('hidden', '') : form.removeAttribute('hidden');
      });
    }
  }

  function refreshCartDrawer() {
    /* Haal cart JSON op en herbouw de drawer inhoud */
    return fetchCartJson().then(function (cart) {
      if (cart) {
        updateCartCount(cart.item_count);
        rebuildDrawer(cart);
      }
      return cart;
    });
  }

  function initCartDrawer() {
    var cartToggle = document.querySelector('[data-cart-toggle]');
    if (cartToggle) {
      cartToggle.addEventListener('click', function () {
        /* Open drawer DIRECT — daarna refresh inhoud op achtergrond */
        openCartDrawer();
        refreshCartDrawer();
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) closeCartDrawer();
    });

    var overlay = document.querySelector('[data-drawer-overlay]');
    if (overlay) overlay.addEventListener('click', closeCartDrawer);
  }

  /* ---------- AJAX add to cart ---------- */
  function initAjaxAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form], form.product-form');
      if (!form) return;
      var idInput = form.querySelector('[name="id"]');
      if (!idInput) return;

      e.preventDefault();
      var button = form.querySelector('[type="submit"]');
      var originalHtml = button ? button.innerHTML : '';
      if (button) { button.disabled = true; button.classList.add('is-loading'); }

      fetch((routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          return response.json().then(function (data) { return { ok: response.ok, data: data }; });
        })
        .then(function (result) {
          if (!result.ok) {
            showToast(result.data.description || result.data.message || (strings.error || 'Er ging iets mis.'));
          } else {
            showToast(strings.added || 'Added to cart \u2713');
            /* Open drawer DIRECT, herbouw inhoud op achtergrond */
            openCartDrawer();
            refreshCartDrawer();
          }
        })
        .catch(function () { showToast(strings.error || 'Er ging iets mis.'); })
        .finally(function () {
          if (button) { button.disabled = false; button.classList.remove('is-loading'); button.innerHTML = originalHtml; }
        });
    });
  }

  /* ---------- Cart line updates (drawer + cart page) ---------- */
  function changeCartLine(key, quantity) {
    return fetch((routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return cart;
      });
  }

  function initCartInteractions() {
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-cart-minus]');
      var plus = e.target.closest('[data-cart-plus]');
      var remove = e.target.closest('[data-cart-remove]');
      if (!minus && !plus && !remove) return;

      var key = (minus || plus || remove).getAttribute('data-key');
      var onCartPage = document.body.classList.contains('template-cart');

      if (remove) {
        e.preventDefault();
        changeCartLine(key, 0).then(function (cart) { afterCartChange(cart, key, onCartPage); });
        return;
      }
      var input = document.querySelector('[data-cart-quantity][data-key="' + key + '"]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      val = minus ? Math.max(0, val - 1) : val + 1;
      input.value = val;
      changeCartLine(key, val).then(function (cart) { afterCartChange(cart, key, onCartPage); });
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-quantity]');
      if (!input) return;
      var key = input.getAttribute('data-key');
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 0) val = 0;
      var onCartPage = document.body.classList.contains('template-cart');
      changeCartLine(key, val).then(function (cart) { afterCartChange(cart, key, onCartPage); });
    });
  }

  function afterCartChange(cart, key, onCartPage) {
    if (onCartPage) {
      var item = cart.items.find(function (i) { return i.key === key; });
      if (!item) {
        var row = document.querySelector('.cart-item[data-key="' + key + '"]');
        if (row) row.remove();
      } else {
        var lineTotal = document.querySelector('.cart-item[data-key="' + key + '"] [data-line-total]');
        if (lineTotal) lineTotal.textContent = formatMoney(item.final_line_price);
      }
      document.querySelectorAll('[data-cart-subtotal]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
      if (cart.item_count === 0) window.location.reload();
    } else {
      rebuildDrawer(cart);
    }
  }

  /* ---------- Product gallery ---------- */
  function initProductGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;
    var mainImage = gallery.querySelector('#ProductMainImage');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (mainImage && full) mainImage.src = full;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------- Variant selector ---------- */
  function initVariantSelector() {
    var form = document.getElementById('ProductFormMain');
    if (!form) return;
    var dataEl = document.querySelector('[data-product-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var optionSelectors = form.querySelectorAll('[data-option-selector]');
    var variantSelect = form.querySelector('[data-variant-select]');
    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-compare-price]');
    var submitBtn = form.querySelector('[data-add-to-cart-main]');
    var addLabel = form.querySelector('[data-add-label]');
    var mainImage = document.getElementById('ProductMainImage');

    function selected() {
      return Array.prototype.map.call(optionSelectors, function (s) { return s.value; });
    }
    function findVariant(sel) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      });
    }
    function onChange() {
      var variant = optionSelectors.length ? findVariant(selected()) : variants[0];
      if (!variant) {
        if (submitBtn) submitBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }
      if (variantSelect) variantSelect.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (variant.featured_image && mainImage) { mainImage.src = variant.featured_image.src; }
      if (submitBtn && addLabel) {
        if (variant.available) { submitBtn.disabled = false; addLabel.textContent = 'Add to cart'; }
        else { submitBtn.disabled = true; addLabel.textContent = 'Sold out'; }
      }
    }
    optionSelectors.forEach(function (s) { s.addEventListener('change', onChange); });
  }

  /* ---------- Quantity selector (product page) ---------- */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var wrap = e.target.closest('.quantity-selector');
      if (!wrap) return;
      var input = wrap.querySelector('[data-qty-input]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      if (minus) val = Math.max(1, val - 1);
      if (plus) val = val + 1;
      input.value = val;
    });
  }

  /* ---------- Collection sort ---------- */
  function initCollectionSort() {
    var sort = document.querySelector('[data-sort-by]');
    if (!sort) return;
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Product accordion ---------- */
  function initAccordions() {
    var containers = document.querySelectorAll('[data-accordion]');
    if (!containers.length) return;

    function openItem(item, panel, trigger) {
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
    function closeItem(item, panel, trigger) {
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.style.maxHeight = '0px';
    }

    containers.forEach(function (container) {
      var triggers = container.querySelectorAll('[data-accordion-trigger]');
      triggers.forEach(function (trigger) {
        var item = trigger.closest('.accordion__item');
        var panel = item.querySelector('[data-accordion-panel]');
        if (!panel) return;
        if (item.classList.contains('is-open')) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
        trigger.addEventListener('click', function () {
          if (item.classList.contains('is-open')) {
            closeItem(item, panel, trigger);
          } else {
            openItem(item, panel, trigger);
          }
        });
      });
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('.accordion__item.is-open [data-accordion-panel]').forEach(function (panel) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      });
    });
  }

  /* ---------- Scroll animations ---------- */
  function initScrollAnimations() {
    var targets = document.querySelectorAll('.section-header, .category-tile, .product-card, .brand-statement__content, .ugc__item, .testimonial');
    targets.forEach(function (el) { el.setAttribute('data-animate', ''); });
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    targets.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    routes.all_products_url = routes.all_products_url || '/collections/all';
    initHeader();
    initMobileMenu();
    initSearch();
    initCartDrawer();
    initAjaxAddToCart();
    initCartInteractions();
    initProductGallery();
    initVariantSelector();
    initQuantity();
    initCollectionSort();
    initAccordions();
    initScrollAnimations();
  });
})();
